// Device / platform detection shared across the consumer PWA.

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

// 'ios' | 'android' | 'other'  (iPadOS 13+ reports as Mac, detected via touch points)
export function getMobileOS() {
  const ua = navigator.userAgent || "";
  if (/android/i.test(ua)) return "android";
  if (/iphone|ipod|ipad/i.test(ua)) return "ios";
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return "ios";
  return "other";
}

// Treat phones + touch iPads as mobile.
export const isMobileDevice = () =>
  /android|iphone|ipad|ipod|iemobile|blackberry|opera mini|mobile/i.test(navigator.userAgent) ||
  (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

// Weak heuristic used only to pre-select install steps on a desktop gate.
export function getDesktopOS() {
  const ua = navigator.userAgent || "";
  if (/Macintosh|Mac OS X/i.test(ua)) return "mac";
  if (/Windows/i.test(ua)) return "windows";
  return "other";
}

// In-app browsers (WhatsApp, Instagram, Facebook, etc.) can't "Add to Home Screen".
// This is the #1 reason an installed-looking link never produces an app icon.
export function isInAppBrowser() {
  const ua = navigator.userAgent || "";
  return /FBAN|FBAV|FB_IAB|Instagram|Line\/|Twitter|WhatsApp|MicroMessenger|Snapchat|Pinterest|; wv\)/i.test(ua);
}
